// @flow
import React, { Component } from "react"
import { rhythm, adjustFontSizeTo } from "../utils/typography"
import { greyXLight, greyMid, primary, primaryDark } from "../utils/colors"
import { getUpcomingWebinars } from "../utils/dates"
import Button from "./Button"
import webinarBg from "../images/webinar-bg.jpg"

type State = {
  upcomingWebinars: Array<WebinarDate> | null,
}

class UpcomingWebinars extends Component<any, State> {
  constructor() {
    super()
  }

  state = {
    upcomingWebinars: null,
  }

  componentDidMount() {
    this.setState({
      upcomingWebinars: getUpcomingWebinars(),
    })
  }

  renderUpcomingWebinars = () => {
    if (this.state.upcomingWebinars) {
      return (
        <ul css={styles.list}>
          {this.state.upcomingWebinars.map(date => (
            <li key={date.value}>{date.label}</li>
          ))}
        </ul>
      )
    }
    return <ul css={styles.list} />
  }

  render() {
    const subtitle =
      "Ready to compete in the digital era with online enrollment? We're ready to show you how! Join us for a live demo of EaseCentral."

    return (
      <div css={styles.container}>
        <div css={styles.visual} />
        <div css={styles.content}>
          <div css={styles.contentInner}>
            <h3 css={styles.headline}>Upcoming Webinars</h3>
            <h5 css={styles.subtitle}>{subtitle}</h5>
            {this.renderUpcomingWebinars()}
            <Button
              css={styles.cta}
              to="http://hr.easecentral.com/live-broker-demo.html"
              target="_blank"
            >
              Join Webinar
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: greyXLight,
    "@media screen and (min-width: 550px)": {
      flexDirection: "row",
    },
  },
  visual: {
    flex: "1",
    padding: `${rhythm(3)} ${rhythm()}`,
    backgroundImage: `url(${webinarBg})`,
    backgroundColor: primaryDark,
    backgroundSize: "cover",
    backgroundPosition: "94%",
    minHeight: rhythm(12),
    margin: rhythm(),
    "@media screen and (min-width: 550px)": {
      minHeight: rhythm(22),
      margin: "0",
    },
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "1",
    padding: `0 ${rhythm()}`,
    color: greyMid,
    textAlign: "center",
    "@media screen and (min-width: 550px)": {
      justifyContent: "flex-start",
      padding: `${rhythm(3)} ${rhythm()}`,
      textAlign: "left",
    },
  },
  contentInner: {
    "@media screen and (min-width: 550px)": {
      paddingLeft: rhythm(),
    },
  },
  headline: {
    color: primaryDark,
    fontWeight: "700",
    "@media screen and (max-width: 800px)": {
      ...adjustFontSizeTo("24px"),
    },
  },
  subtitle: {
    fontSize: "17px",
    fontWeight: "600",
    lineHeight: "29px",
    "@media screen and (min-width: 800px)": {
      width: "75%",
    },
  },
  list: {
    minHeight: rhythm(7 / 2),
    padding: "0",
    margin: `${rhythm()} 0`,
    listStyle: "none",
    color: primary,
    fontWeight: "600",
    "> li": {
      padding: "0",
      margin: `0 0 ${rhythm(1 / 4)} 0`,
    },
    "@media screen and (max-width: 400px)": {
      ...adjustFontSizeTo("14px"),
    },
    "@media screen and (max-width: 330px)": {
      ...adjustFontSizeTo("12px"),
    },
  },
  cta: {
    margin: `${rhythm(1 / 2)} 0 ${rhythm()} 0`,
  },
  link: {
    color: greyMid,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}

export default UpcomingWebinars



// WEBPACK FOOTER //
// ./src/components/UpcomingWebinars.js